/**
 * Serviço de logs para o backend (opcional).
 * Configure VITE_LOGGING_API_URL no .env para enviar eventos; caso contrário só console.
 */

const LOG_API_URL = typeof import.meta !== 'undefined' && import.meta.env?.VITE_LOGGING_API_URL;

function getDeviceInfo(extra = {}) {
  if (typeof window === 'undefined') {
    return { timestamp: new Date().toISOString(), ...extra };
  }
  const ua = window.navigator.userAgent || '';
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  return {
    timestamp: new Date().toISOString(),
    url: window.location.href,
    origin: window.location.origin,
    pathname: window.location.pathname,
    search: window.location.search,
    userAgent: ua,
    screenWidth: window.screen?.width,
    screenHeight: window.screen?.height,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    isMobile,
    ...extra,
  };
}

/**
 * Envia um evento de log para o backend (se VITE_LOGGING_API_URL estiver definido).
 * Payload é enviado como JSON no body. Use sendLog para eventos do fluxo QR e erros.
 *
 * @param {string} event - Nome do evento (ex: qr_link_opened, qr_params_applied, app_error)
 * @param {Record<string, unknown>} [payload] - Dados adicionais
 */
export function sendLog(event, payload = {}) {
  const body = {
    event,
    ...payload,
    ...getDeviceInfo(),
  };

  if (LOG_API_URL) {
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
    const ok = navigator.sendBeacon?.(LOG_API_URL, blob);
    if (!ok) {
      fetch(LOG_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch((err) => console.warn('[LoggingService] Falha ao enviar log:', err));
    }
  }

  if (import.meta.env?.DEV || !LOG_API_URL) {
    console.log('[LoggingService]', event, body);
  }
}

/**
 * Log quando a página é aberta com link para receber (pay=1). Chamar o mais cedo possível.
 */
export function logQRLinkOpened(params) {
  sendLog('qr_link_opened', {
    reason: 'page_load_with_pay_param',
    params: params || Object.fromEntries(new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')),
  });
}

/**
 * Log quando o formulário aplica (ou não) os parâmetros do link para receber.
 */
export function logQRParamsResult(success, detail) {
  sendLog(success ? 'qr_params_applied' : 'qr_params_skipped', {
    success,
    ...detail,
  });
}

/**
 * Log de erro não tratado (para correlacionar com tela em branco / falhas).
 */
export function logAppError(message, stack) {
  sendLog('app_error', { message, stack });
}

export default { sendLog, logQRLinkOpened, logQRParamsResult, logAppError };
